import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Come si svolge il primo colloquio?",
    a: "Il primo colloquio è uno spazio di conoscenza reciproca. Insieme esploreremo la tua richiesta, gli obiettivi e le aspettative, costruendo le basi di un eventuale percorso. Dura circa 50 minuti.",
  },
  {
    q: "Le sedute si possono fare anche online?",
    a: "Sì, offro sedute sia in presenza presso lo studio di Chivasso, sia online tramite videochiamata su piattaforma sicura. Puoi indicare la tua preferenza al momento della prenotazione.",
  },
  {
    q: "Quanto dura un percorso?",
    a: "Non esiste una durata standard. Alcuni percorsi si chiudono in pochi mesi, altri richiedono più tempo. Insieme valuteremo periodicamente l'andamento e il senso del lavoro.",
  },
  {
    q: "Le informazioni che condivido sono riservate?",
    a: "Assolutamente sì. Tutto ciò che emerge nelle sedute è tutelato dal segreto professionale previsto dal codice deontologico degli psicologi.",
  },
  {
    q: "Cosa è la comunicazione ipnotica?",
    a: "È uno stato di rilassamento profondo, naturale e sicuro, in cui mente e corpo dialogano più liberamente. Non si perde mai il controllo: si guadagna spazio interno.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 lg:py-32 bg-[#E9EFE4]"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-12">
          <span className="eyebrow" data-testid="faq-eyebrow">Domande frequenti</span>
          <h2
            className="font-serif-elegant mt-6 text-3xl lg:text-5xl font-light tracking-tight text-[#3D3B3A] leading-tight"
            data-testid="faq-title"
          >
            Le risposte<br />
            <span className="italic text-[#6B8568]">a ciò che ti chiedi</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#CFD9C5] last:border-b-0"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif-elegant text-lg lg:text-xl text-[#3D3B3A] hover:text-[#7E9C7B] hover:no-underline py-6 text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#73706E] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
